<div class="title-container">
    <img
        *ngIf="iconUrl"
        [src]="iconUrl"
        alt="{{ title }} icon"
        class="title-icon"
        [style.color]="iconColor"
        [ngClass]="{'icon-outlined': iconVariant === 'outlined'}"
    />
    <mat-icon
        *ngIf="!iconUrl && icon"
        class="title-icon"
        [style.color]="iconColor"
        [fontSet]="iconVariant === 'outlined' ? 'material-icons-outlined' : 'material-icons'"
    >{{ icon }}</mat-icon>

    <span class="title-label">{{ title }}</span>

    <button
        *ngIf="showLink"
        type="button"
        class="title-link"
        [disabled]="disabled"
        (click)="click.emit('title click')">
        <span class="link-label"></span>
        <mat-icon class="link-icon">{{ viewAllIconKey }}</mat-icon>
    </button>
</div>
